import {
  fetchEmailsForThread,
  updateThreadByStatus,
  updateThreadByLinkingEntities,
  fetchLinkedEntitiesForThread,
} from '../routines/emailRoutines';
import { fetchIntegrations } from '../routines/integrations/integrationDataRoutines';

const initialThreadState = {
  loading: false,
  error: null,
  messages: [],
};

const initialThreadByLinkingEntitiesState = {
  loading: false,
  error: null,
  // data: {},
  organizations: [],
  accounts: [],
};

const initialState = {
  threads: {},
  provider: null,
  linkedEntities: {},

  initialThreadByStatusState: {
    loading: {},
    isSuccess: {},
    hideStatus: {},
  },

  initialThreadByLinkingEntitiesState: {
    loading: false,
    error: null,
    organizations: [],
    accounts: [],
  },
};

function emailsReducer(state = initialState, action) {
  switch (action.type) {
    case fetchIntegrations.SUCCESS: {
      const { user: userIntegrations } = action.payload;

      const provider = userIntegrations.find(
        (integration) =>
          integration.integrationContext?.communicationType === 'Email'
      );

      return {
        ...state,
        provider,
      };
    }
    case fetchEmailsForThread.TRIGGER: {
      const { threadId } = action.payload;

      return {
        ...state,
        threads: {
          ...state.threads,
          [threadId]: {
            ...(state.threads[threadId] || initialThreadState),
            loading: true,
          },
        },
      };
    }
    case fetchEmailsForThread.SUCCESS: {
      const {
        threadId,
        response: { data: messages },
      } = action.payload;

      return {
        ...state,
        threads: {
          ...state.threads,
          [threadId]: {
            ...state.threads[threadId],
            loading: false,
            messages,
          },
        },
      };
    }
    case fetchEmailsForThread.FAILURE: {
      const { threadId, error } = action.payload;

      return {
        ...state,
        threads: {
          ...state.threads,
          [threadId]: {
            ...state.threads[threadId],
            loading: false,
            error,
          },
        },
      };
    }
    case updateThreadByStatus.TRIGGER:
      return {
        ...state,
        initialThreadByStatusState: {
          ...state.initialThreadByStatusState,
          loading: true,
          isSuccess: false,
        },
      };

    case updateThreadByStatus.SUCCESS:
      return {
        ...state,
        initialThreadByStatusState: {
          ...state.initialThreadByStatusState,
          loading: false,
          isSuccess: true,
        },
      };

    case updateThreadByStatus.FAILURE:
      return {
        ...state,
        initialThreadByStatusState: {
          ...state.initialThreadByStatusState,
          loading: false,
          isSuccess: false,
        },
      };
    case updateThreadByLinkingEntities.TRIGGER:
      return {
        ...state,
        initialThreadByLinkingEntitiesState: {
          ...state.initialThreadByLinkingEntitiesState,
          loading: true,
          isSuccess: false,
        },
      };

    case updateThreadByLinkingEntities.SUCCESS:
      return {
        ...state,
        initialThreadByLinkingEntitiesState: {
          ...state.initialThreadByLinkingEntitiesState,
          loading: false,
          isSuccess: true,
        },
      };

    case updateThreadByLinkingEntities.FAILURE:
      return {
        ...state,
        initialThreadByLinkingEntitiesState: {
          ...state.initialThreadByLinkingEntitiesState,
          loading: false,
          isSuccess: false,
        },
      };

    case fetchLinkedEntitiesForThread.TRIGGER: {
      const { threadId } = action.payload;

      return {
        ...state,
        linkedEntities: {
          ...state.linkedEntities,
          [threadId]: {
            ...(state.linkedEntities[threadId] ||
              initialThreadByLinkingEntitiesState),
            loading: true,
          },
        },
      };
    }
    case fetchLinkedEntitiesForThread.SUCCESS: {
      const {
        threadId,
        response: { data: linkedEntities },
      } = action.payload;

      const { accounts, organizations } = linkedEntities;

      return {
        ...state,
        linkedEntities: {
          ...state.linkedEntities,
          [threadId]: {
            ...state.linkedEntities[threadId],
            loading: false,
            organizations,
            accounts,
          },
        },
      };
    }
    case fetchLinkedEntitiesForThread.FAILURE: {
      const { threadId, error } = action.payload;

      return {
        ...state,
        linkedEntities: {
          ...state.linkedEntities,
          [threadId]: {
            ...state.linkedEntities[threadId],
            loading: false,
            error,
          },
        },
      };
    }
    default:
      return state;
  }
}

export default emailsReducer;
